import { useQuery } from '@tanstack/react-query';
import { getCommunityExpertiseGeneral } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';

export const useCommunityExpertiseGeneralQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'community-expertise-general' ],
    queryFn: getCommunityExpertiseGeneral,
    select: (data) => data.data,
    ...opts,
  });
};
